import { useEffect } from 'react';
import { POLIGONO_BRAND, getProductBrand } from 'constants/brand-constants';

export const useBrandTheme = (bizId?: string | null) => {
    useEffect(() => {
        const brand = getProductBrand(bizId);
        document.documentElement.style.setProperty('--primary-color', brand.primaryColor);
        document.documentElement.style.setProperty('--secondary-color', brand.secondaryColor);
        document.documentElement.style.setProperty('--tertiary-color', brand.tertiaryColor);

        const favicon = document.querySelector<HTMLLinkElement>('link[rel="shortcut icon"]');
        if (favicon) {
            favicon.href = brand.branchName === POLIGONO_BRAND.branchName
                ? '/favicon-poligono.webp'
                : '/favicon.ico';
        }
    }, [bizId]);
};
